var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsOptional, IsString, IsUUID, ValidateIf } from 'class-validator';
import { CustomFormElementLiteDto } from './custom-form-element.lite.dto.js';
export class UpdateCustomFormElementAnswerDto {
    answer;
    customFormElementId;
    customFormElement;
}
__decorate([
    IsOptional(),
    Expose(),
    ValidateIf((_, value) => value !== null),
    IsString(),
    __metadata("design:type", Object)
], UpdateCustomFormElementAnswerDto.prototype, "answer", void 0);
__decorate([
    IsOptional(),
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], UpdateCustomFormElementAnswerDto.prototype, "customFormElementId", void 0);
__decorate([
    IsOptional(),
    Expose(),
    Type(() => CustomFormElementLiteDto),
    __metadata("design:type", Function)
], UpdateCustomFormElementAnswerDto.prototype, "customFormElement", void 0);
//# sourceMappingURL=update-custom-form-element-answer.dto.js.map